import { render, staticRenderFns } from "./GuidedTours.vue?vue&type=template&id=51b4d02e&scoped=true&"
import script from "./GuidedTours.vue?vue&type=script&lang=ts&"
export * from "./GuidedTours.vue?vue&type=script&lang=ts&"
import style0 from "./GuidedTours.vue?vue&type=style&index=0&id=51b4d02e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4d02e",
  null
  
)

export default component.exports